import React, { ReactNode } from "react";
import styled from "styled-components";
import { FlexDiv } from "../FlexDiv";

interface RadioProps {
  value: string;
  checked?: boolean;
  onChange?: (value: string) => void;
  label?: string | null;
  price?: string | null;
  description?: string | null;
  name?: string;
}

const StyledRadio = styled.label`
  display: flex;
  flex-direction: column;
  align-items: start;
  cursor: pointer;
  margin-bottom: 8px;
  font-size: 14px;

  input {
    margin-right: 8px;
  }
`;

export const Radio: React.FC<RadioProps> = ({
  value,
  checked,
  onChange,
  label,
  price,
  description,
  name,
}) => {
  return (
    <StyledRadio>
      <FlexDiv>
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={() => onChange?.(value)}
        />
        <strong>
          {label} {price && `- ${price}`}
        </strong>
      </FlexDiv>
      <br />
      <FlexDiv style={{ minWidth: "100%", fontSize: 14, lineHeight: "normal" }}>
        {description}
      </FlexDiv>
    </StyledRadio>
  );
};

interface RadioGroupProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  children: ReactNode;
}

const StyledRadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 20px 0;
`;

export const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  value,
  onChange,
  children,
}) => {
  return (
    <StyledRadioGroup>
      {React.Children.map(children, (child) => {
        if (React.isValidElement<RadioProps>(child)) {
          return React.cloneElement(child, {
            checked: child.props.value === value,
            onChange,
            name,
          });
        }
        return child;
      })}
    </StyledRadioGroup>
  );
};
